/**
 * What Sentry may collect beyond the error itself — one setting for every SDK
 * this platform initialises on the web and the server (both portals, the API,
 * the brain, the workers).
 *
 * Sentry 11 replaced `sendDefaultPii` with `dataCollection`, and its defaults
 * collect far more than v10 did with `sendDefaultPii` unset, as here: user
 * fields read from instrumentation, cookies, every request and response body,
 * database query values, AI model inputs and outputs, queue job arguments and
 * local variables. On this platform those carry citizens' personal data and
 * their CoPilot conversations, which do not go to a third party by default.
 *
 * So this holds v10's level: request headers and URL query parameters (Sentry's
 * sensitive-key denylist still filters both), nothing else; and the 7 lines of
 * source context v10 captured.
 */
export const SENTRY_DATA_COLLECTION = {
  userInfo: false,
  cookies: false,
  httpHeaders: true,
  httpBodies: [],
  urlQueryParams: true,
  graphQL: { document: false, variables: false },
  genAI: { inputs: false, outputs: false },
  databaseQueryData: false,
  queues: false,
  stackFrameVariables: false,
  frameContextLines: 7,
} as const;
